import FormBaseModel from '@cp-models/FormBaseModel';
import Address from '@core/../../../../Clients/Resources/assets/js/models/Address'
import Contact from '@core/../../../../Clients/Resources/assets/js/models/Contact'
import Plan from '@cp-models-common/Plan'
import User from '@core/../../../../Clients/Resources/assets/js/models/User'

export default class Company extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'id_address': 'number',
            'nfs_address_id': 'number',
            'nfs_legal_document': 'string',
            'nfs_legal_name': 'string',
            'owner_name': 'string',
            'owner_phone': 'string',
            'charge_email': 'string',
            'charge_name': 'string',
            'charge_phone': 'string',
            'certificate_expiration_date': 'any',
            'has_pos_vindi': 'boolean',
            'address': Address,
            'nfs_address': Address,
            'contacts': [Contact],
            'users': [User],
            'plan': Plan
        }
    }

    get certificateExpirationDate()
    {
        return this.formatDate(this.certificate_expiration_date)
    }

}
